// Convert date to format YYYY-MM-DD
export const formatDate = (date: Date): string => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

// The query Lambdas return America/New_York wall-clock strings ('yyyy-MM-dd
// HH:mm:ss', sometimes with a 'T' separator) that name no zone, so `new Date`
// reads them in the reviewer's zone. That zone's own spring-forward day has no
// 02:xx, and JS silently normalizes it forward: a New York 02:30 trip rendered
// as 03:30 to a reviewer in Europe/Berlin. Read those as UTC and format in UTC
// so the digits survive verbatim in every timezone. Values that do name an
// instant (an ISO string ending in Z or an offset) keep the local conversion.
const WALL_CLOCK_RE = /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}(:\d{2})?(\.\d+)?$/;

// Convert date string to format MM/DD/YYYY HH:MM:SS
export const convertDateFormat = (date: string) => {
    const isWallClock = WALL_CLOCK_RE.test(date || '');
    const value = isWallClock ? new Date(`${date.replace(' ', 'T')}Z`) : new Date(date || '');
    return value.toLocaleString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true,
        ...(isWallClock ? { timeZone: 'UTC' } : {})
    })
}
